export const Countries: Record<string, string> = {
  USA: 'United States',
};

export const CountryOptions = Object.keys(Countries).map((key) => ({ value: key, label: Countries[key] }));
